export default __webpack_public_path__ + "static/media/hotting-grill-logo.a38586e9.webp";